import React, { useEffect, useContext, useState } from 'react';
import Button from '@material-ui/core/Button';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import TextField from '@material-ui/core/TextField';
import Checkbox from '@material-ui/core/Checkbox';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import { makeStyles } from '@material-ui/core';
import Modal from '@material-ui/core/Modal';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';

import { Context as PropertyContext } from '../../context/property.context';
import { Context as AuthContext } from '../../context/auth.context';

const Filters = (props) => {
	const { state, setChecked, clearFilters } =
		React.useContext(PropertyContext);
	const auth = React.useContext(AuthContext);

	if(auth.state.merchant.enableCoris == 1){
		return null
	}

	if (props.isMobile) {
		return (
			<Modal
				aria-labelledby="transition-modal-title"
				aria-describedby="transition-modal-description"
				className="cart-modal"
				open={props.modalOpen}
				onClose={() => props.setModalOpen(false)}
				closeAfterTransition
				BackdropComponent={Backdrop}
				BackdropProps={{
					timeout: 500,
				}}
			>
				<Fade in={props.modalOpen}>
					<div
						id="cart-content"
						style={{ height: 'auto', position: 'relative' }}
					>
						<IconButton
							onClick={() => props.setModalOpen(false)}
							style={{ position: 'absolute', top: 15, right: 15 }}
						>
							<CloseIcon />
						</IconButton>
						{auth.state.merchant.visibleFilters.includes(
							'status'
						) && (
							<>
								<Typography variant="subtitle1">
									Status
								</Typography>
								<FormGroup style={{ marginBottom: 25 }}>
									{state.statusFilters.map((filter) => {
										return (
											<FormControlLabel
												control={
													<Checkbox
														checked={filter.checked}
														onChange={() =>
															setChecked({
																name:
																	filter.name ===
																	'Paid'
																		? 1
																		: 0,
																filter: 'statusFilters',
																prop: 'paid',
															})
														}
														name={filter.name}
													/>
												}
												label={filter.name}
											/>
										);
									})}
								</FormGroup>
							</>
						)}
						{auth.state.merchant.visibleFilters.includes(
							'type'
						) && (
							<>
								<Typography variant="subtitle1">
									Type
								</Typography>
								<FormGroup style={{ marginBottom: 25 }}>
									{state.typeFilters.map((filter) => {
										return (
											<FormControlLabel
												control={
													<Checkbox
														checked={filter.checked}
														onChange={() =>
															setChecked({
																name: filter.name,
																filter: 'typeFilters',
																prop: 'recordType',
															})
														}
														name={filter.name}
													/>
												}
												label={filter.name}
											/>
										);
									})}
								</FormGroup>
							</>
						)}
						{auth.state.merchant.visibleFilters.includes(
							'year'
						) && (
							<>
								<Typography variant="subtitle1">
									Years
								</Typography>
								<FormGroup>
									{state.yearFilters.map((filter) => {
										return (
											<FormControlLabel
												control={
													<Checkbox
														checked={filter.checked}
														onChange={() =>
															setChecked({
																name: filter.name,
																filter: 'yearFilters',
																prop: 'taxYear',
															})
														}
														name={filter.name}
													/>
												}
												label={filter.name}
											/>
										);
									})}
								</FormGroup>
							</>
						)}
						<Button
							variant="contained"
							color="primary"
							onClick={() => props.setModalOpen(false)}
							fullWidth
							style={{ marginTop: 10, height: 40 }}
						>
							Save Filters
						</Button>
						<Button
							variant="text"
							color="primary"
							onClick={clearFilters}
							fullWidth
							style={{ marginTop: 10, height: 40 }}
						>
							Clear All
						</Button>
					</div>
				</Fade>
			</Modal>
		);
	}

	if (auth.state.merchant.visibleFilters.length === 0) {
		return null;
	}

	return (
		<div style={styles.container} className="propertyFilters">
			
			{auth.state.merchant.visibleFilters.includes('status') && (
				<>
					<Typography variant="subtitle1">Status</Typography>
					<FormGroup style={{ marginBottom: 25 }}>
						{state.statusFilters.map((filter) => {
							return (
								<FormControlLabel
									control={
										<Checkbox
											checked={filter.checked}
											onChange={() =>
												setChecked({
													name:
														filter.name === 'Paid'
															? 1
															: 0,
													filter: 'statusFilters',
													prop: 'paid',
												})
											}
											name={filter.name}
										/>
									}
									label={filter.name}
								/>
							);
						})}
					</FormGroup>
				</>
			)}
			{auth.state.merchant.visibleFilters.includes('type') && (
				<>
					<Typography variant="subtitle1">Type</Typography>
					<FormGroup style={{ marginBottom: 25 }}>
						{state.typeFilters.map((filter) => {
							return (
								<FormControlLabel
									control={
										<Checkbox
											checked={filter.checked}
											onChange={() =>
												setChecked({
													name: filter.name,
													filter: 'typeFilters',
													prop: 'recordType',
												})
											}
											name={filter.name}
										/>
									}
									label={filter.name}
								/>
							);
						})}
					</FormGroup>
				</>
			)}
			{auth.state.merchant.visibleFilters.includes('year') && (
				<>
					<Typography variant="subtitle1">Years</Typography>
					<FormGroup>
						{state.yearFilters.map((filter) => {
							return (
								<FormControlLabel
									control={
										<Checkbox
											checked={filter.checked}
											onChange={() =>
												setChecked({
													name: filter.name,
													filter: 'yearFilters',
													prop: 'taxYear',
												})
											}
											name={filter.name}
										/>
									}
									label={filter.name}
								/>
							);
						})}
					</FormGroup>
				</>
			)}
			<Button
				variant="text"
				color="primary"
				onClick={clearFilters}
				style={{ marginTop: 10, height: 40 }}
			>
				Clear All
			</Button>
		</div>
	);
};

const styles = {
	container: {
		marginRight: 25,
		paddingRight: 0,
	},
};

export default Filters;
